"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const fields_validators_1 = require("@App/helpers/work-entities/fields-validators");
const string_escape_newlines_1 = require("@App/helpers/string-escape-newlines");
const react_1 = __importDefault(require("react"));
const RecordingCardHeader = (props) => {
    const { title, data, editFunction, removeFunction } = props;
    return (react_1.default.createElement("div", { className: 'head' },
        react_1.default.createElement("p", { className: `bold ${(0, fields_validators_1.recordingTitleInvalidCheck)(title) ? 'red-text' : ''}` }, title ? (0, string_escape_newlines_1.stringEscapeNewlines)(title) : ''),
        react_1.default.createElement("div", { className: 'controls' },
            editFunction && (react_1.default.createElement("span", { className: 'small-2 medium', onClick: () => editFunction(data) }, "Edit")),
            removeFunction && (react_1.default.createElement("span", { className: 'small-2 medium', onClick: () => removeFunction(data) }, "Remove")))));
};
exports.default = RecordingCardHeader;
